import { useState } from "react";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { makeStyles } from "@material-ui/core/styles";
import componentStyles from "assets/theme/views/admin/react-bs-table";
import { Tooltip, IconButton } from "@material-ui/core";

import { columnTextField } from "utils/tables-utils";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

import AddIcon from "@mui/icons-material/Add";

const useTabStyles = makeStyles({
  ...componentStyles,
});

const useStyles = makeStyles({
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
});

export default function TableDesireProduct({
  dataTable,
  search,
  currentPage,
  totalRegistros,
  setProductSelected,
  onCloseTable,
}) {
  const classes = { ...useTabStyles(), ...useStyles() };
  const [loading, setLoading] = useState(false);

  const fotoProdutoItem = (cell, row) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ImagePlaceholder
          className={classes.img}
          alt="Imagem do item do pedido"
          src={row?.Foto}
          width={64}
          widthOnError={40}
          imagePreviewTitle={`Produto ${row?.Codigo}`}
        />
      </div>
    );
  };

  const addItemButtom = (cell, row) => {
    return (
      <Tooltip title="Adicionar produto">
        <IconButton
          aria-label="incluir"
          onClick={() => {
            setProductSelected(row);
            onCloseTable();
          }}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  };

  const columnModel = [
    {
      dataField: "Foto",
      text: "Imagem",
      headerAlign: "center",
      align: "center",
      sort: false,
      formatter: fotoProdutoItem,
      csvExport: false,
    },
    columnTextField(
      {
        dataField: "Nome",
        text: "Descrição Produto",
        align: "left",
        formatter: (cell) => {
          return <p style={{ whiteSpace: "normal" }}>{cell}</p>;
        },
      },
      false
    ),
    {
      dataField: "incluir",
      text: "",
      isDummyField: true,
      headerStyle: { width: 45 },
      formatter: addItemButtom,
    },
  ];

  const doSearch = async (page) => {
    setLoading(true);

    try {
      await search({ page });
    } catch (error) {
      console.error("Error searching:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    doSearch(page);
  };

  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="Codigo"
      dataTable={dataTable}
      columnModel={columnModel}
      headerTitle="Produtos"
      pagination={{
        options: ["10"],
        defaultOption: 10,
        totalSize: totalRegistros,
        showTotal: false,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: 10,
      }}
      loading={loading}
      notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
      bootstrapTableProps={{
        remote: true,
        onTableChange: () => {},
      }}
    />
  );
}
